import { ProjectsItem } from "./Projects-Item.jsx";
import React, { useState, useEffect } from "react";

const projectItems = [
    {
        name: "Simple-Task",
        link: "https://simple-list-mk.netlify.app/",
        description: {
            first: "Task Management",
            second: "User-Friendly Interface",
            third: "Task Status Tracking",
        },
        ImageClass: [
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523703/Portfolio/Projects/Task-list/qusjjolffwzdba3ujspi.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523700/Portfolio/Projects/Task-list/gl6vfxknzq7j1kgkfaz1.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523701/Portfolio/Projects/Task-list/jq750ct5jpzbgih7ropg.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523701/Portfolio/Projects/Task-list/fccogge573xn3laplpl5.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523701/Portfolio/Projects/Task-list/py28pj2enjyt7zv3aczo.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523701/Portfolio/Projects/Task-list/jovhyh4dx3hclj4qvnsb.jpg",
        ],
    },
    {
        name: "Nutra-Stride",
        link: "https://nutra-stride.netlify.app/",
        description: {
            first: "Find best exercises for your condition",
            second: "Match accurate diet to fitness",
            third: "Read news about tech and nutrition",
        },
        ImageClass: [
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523801/Portfolio/Projects/NutraStride/xeyonhhun5refo2aggqw.jpg",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523800/Portfolio/Projects/NutraStride/vfhuycxrssic6abxwmbj.jpg",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523801/Portfolio/Projects/NutraStride/tcrv4plmnpbbvv1flxis.jpg",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523801/Portfolio/Projects/NutraStride/acsxpd7qeod0o1yhpq61.jpg",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523799/Portfolio/Projects/NutraStride/exlzpeigusrmbkm6tlgb.jpg",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523800/Portfolio/Projects/NutraStride/qcartvimx0q57spitkvq.jpg",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523802/Portfolio/Projects/NutraStride/bvkuu0mmilb2tfiaucgt.png",
        ],
    },
    {
        name: "Travel-Blog",
        link: "https://travel-blog-a62ef.web.app/",
        description: {
            first: "Share travel experiences",
            second: "Interactive Community",
            third: "Rich Multimedia Content",
        },
        ImageClass: [
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523788/Portfolio/Projects/travel/e7tmdmswnrwc4swohqqb.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523788/Portfolio/Projects/travel/t6fn8cghlgyud30yezzq.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523786/Portfolio/Projects/travel/j9fowk9lgqlfuf6gzh7v.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523789/Portfolio/Projects/travel/qbfgqwbi7snfo3x0lhqj.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523785/Portfolio/Projects/travel/zpbrt0s6otxxoz0ygjal.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523784/Portfolio/Projects/travel/rp3iandxosulebcyy16n.png",
        ],
    },

    {
        name: "Filmbase",
        link: "http://filmbased.netlify.app/",
        description: {
            first: "Search in library of your favorite films",
            second: "Control time and number of watched collections",
            third: "Dive deep into film details",
        },
        ImageClass: [
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523888/Portfolio/Projects/filmbase/jodx0zpuctnmtxjfnbd0.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523887/Portfolio/Projects/filmbase/h6wubb8o85tv6ppbpdjz.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523881/Portfolio/Projects/filmbase/xt764ggzwygvl3gebdku.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523883/Portfolio/Projects/filmbase/t9bsh7r77k0vbixe7fj5.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523891/Portfolio/Projects/filmbase/vpdd6gbjifog95rzbswa.png",
        ],
    },
    {
        name: "Currency Converter+",
        link: "https://currency-converter-plus.netlify.app/",
        description: {
            first: "Covert Money",
            second: "Check rates for currency",
            third: "Find out past rates for any day",
        },
        ImageClass: [
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523815/Portfolio/Projects/currency/ktqnzouqkteaasc9a7wl.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523815/Portfolio/Projects/currency/ttapb8ukp4axdfddldr8.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523815/Portfolio/Projects/currency/y6jaep6wmfognhpbnyak.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523813/Portfolio/Projects/currency/jdzl8h84rdinkjr09twr.png",
            "https://res.cloudinary.com/dx9rdmmff/image/upload/v1713523813/Portfolio/Projects/currency/nwmklzkayt0ijuhbvok6.png",
        ],
    },
];

export const Projects = ({ myWorkRef }) => {
    const [arrows, setArrows] = useState(Array(projectItems.length).fill(0));

    useEffect(() => {
        const drone = document.getElementById("droned");

        const handleMouseEnter = (e) => {
            const rect = drone.getBoundingClientRect();
            const mouseX = e.clientX;
            const mouseY = e.clientY;

            if (mouseX < rect.left + 50) {
                drone.style.transform = "translateX(50px) rotate(-15deg)";
            } else if (mouseX > rect.right - 50) {
                drone.style.transform =
                    "translateX(-100px) translateY(50px) rotate(15deg)";
            } else if (mouseY < rect.top + 50) {
                drone.style.transform = "translateY(50px) rotate(15deg)";
            } else if (mouseY > rect.bottom - 50) {
                drone.style.transform =
                    "translateX(-100px) translateY(50px) rotate(-15deg)";
            }
        };

        const handleMouseLeave = () => {
            // Reset the position when the mouse leaves
            drone.style.transform = "translateX(0px) rotate(0deg)";
        };

        drone.addEventListener("mouseenter", handleMouseEnter);
        drone.addEventListener("mouseleave", handleMouseLeave);

        // Clean up event listeners when the component unmounts
        return () => {
            drone.removeEventListener("mouseenter", handleMouseEnter);
            drone.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, []); // Empty dependency array means this effect runs once after component mounts

    return (
        <div className="Projects" ref={myWorkRef}>
            <div className="Drone" id="droned"></div>
            <h1 className="Projects-Header">Projects</h1>
            <div className="Projects-Cont">
                {projectItems.map((item, index) => (
                    <ProjectsItem
                        key={index}
                        item={item}
                        arrows={arrows}
                        setArrows={setArrows}
                        index={index}
                    />
                ))}
            </div>
        </div>
    );
};
